// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"346":"c6e199e0","503":"02d9f6cb","755":"062d7a36"}[chunkId] + ".chunk.js";
};